import { makeCRUDSlice } from '@redux/crudCreator';
import {
  MODEL_NAME,
  calculateShippingFee,
  getOriginalOrder,
  ordersExchangeActions,
} from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersExchangeActions, {
  // eslint-disable-next-line
  [calculateShippingFee.fulfilled as any]: (state, { payload }) => {
    state.shippingFee = payload;
  },
  // eslint-disable-next-line
  [getOriginalOrder.fulfilled as any]: (state, { payload }) => {
    state.originalOrder = payload;
  },
});

export default slice.reducer;
